import initTheme from "./scripts/theme";
import initChat from "./scripts/chat";
import initArch from "./scripts/arch";
// Case-study pages (marketplace.html, blog-platform.html)

initTheme();
initChat();
initArch();
